import Styles from '../WizardsDrawerV4.module.scss'
import { ContentCard, ContentCardProps } from 'screens/blaze/Home/MobileHome/ContentCard/ContentCard'
import { WizardOpener } from '../WizardOpener/WizardOpener'
import cx from 'classnames'
import { Button } from 'blaze-ui/Button'
import { Level, LevelProps, Wizard } from '../Types'

type Props = LevelProps & {
  className?: string
  title: string
  items: Array<
    ContentCardProps & {
      wizard?: Wizard
      level?: Level
    }
  >
  handleSeeAll?: () => void
}

export const CardSection = (props: Props) => {
  const { className, title, handleSeeAll, items, handleLevel } = props

  return (
    <>
      <h3>{title}</h3>
      <div className={cx(Styles.section, className)}>
        <div className={cx(Styles.cardSection)}>
          {items.map((item) => {
            const card = (
              <ContentCard
                key={item.title}
                className={cx(Styles.contentCard, item.className, { [Styles.single]: items.length === 1 })}
                title={item.title}
                description={item.description}
                imgSrc={item.imgSrc}
                textWidth={item.textWidth}
                onPress={item.level ? handleLevel(item.level) : undefined}
              />
            )

            if (item.wizard) {
              return (
                <WizardOpener key={item.title} type={item.wizard}>
                  {card}
                </WizardOpener>
              )
            }

            return card
          })}
        </div>
        {handleSeeAll && (
          <Button variant="tertiary" fullWidth onPress={handleSeeAll}>
            See All
          </Button>
        )}
      </div>
    </>
  )
}
